import React from 'react';
import { ShieldCheck, Lock, CreditCard, Star, Zap } from 'lucide-react';
export function Hero() {
  return <section className="bg-gradient-to-br from-[#1A1A1A] via-[#2C2C2A] to-[#3A2030] text-white pt-10 sm:pt-16 pb-8 sm:pb-12 px-5 text-center overflow-hidden" data-id="element-174">
      <div className="max-w-6xl mx-auto flex flex-col items-center" data-id="element-175">
        <div className="inline-block bg-dorado text-[#1A1A1A] font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4 sm:mb-6 text-[8px]" data-id="element-176">
          🌸 Kit Profesional Para Esteticistas — Solucionesya.shop
        </div>

        <h1 className="text-[clamp(26px,5vw,46px)] font-extrabold leading-[1.15] max-w-[820px] mx-auto mb-4 sm:mb-5" data-id="element-177">
          Tu año de trabajo en estética
          <br data-id="element-178" />
          <span className="text-dorado" data-id="element-179">resuelto en un fin de semana.</span>
        </h1>

        <div className="relative w-full max-w-4xl mx-auto my-5 sm:my-7" data-id="element-180">
          <div className="absolute inset-0 bg-rosa/20 blur-[100px] rounded-full" data-id="element-181"></div>
          <img src="https://cdn.magicpatterns.com/uploads/e7fRbGjKJhrbru7xjy2Ujf/mockup_sin_fondo_estetica.png" alt="Kit Profesional de Imagen y Gestión" loading="eager" fetchPriority="high" className="relative z-10 w-[70%] h-auto mx-auto object-contain drop-shadow-2xl" data-id="element-182" />
        </div>

        <p className="text-[clamp(15px,2.5vw,18px)] text-[#CCCCCC] max-w-[660px] mx-auto mb-6 sm:mb-8 leading-relaxed" data-id="element-183">
          El kit completo para que{' '}
          <strong className="text-white" data-id="element-184">
            tus clientas te vean como la profesional que ya sos
          </strong>
          : presupuestos listos, fichas de clienta, mensajes para cada turno,
          menú de precios y plan de redes —{' '}
          <strong className="text-white" data-id="element-185">
            descargás hoy y aplicás mañana.
          </strong>
        </p>

        <a href="#precios" className="inline-block bg-gradient-to-br from-rosa to-rosa-oscuro text-white text-[17px] font-bold px-10 py-4 rounded-full shadow-[0_8px_30px_rgba(212,83,126,0.45)] hover:-translate-y-0.5 hover:shadow-[0_12px_40px_rgba(212,83,126,0.55)] transition-all duration-150 tracking-wide mb-6 sm:mb-8" data-id="element-186">
          💅 QUIERO MI KIT PROFESIONAL AHORA
        </a>

        <div className="flex justify-center flex-wrap gap-4 sm:gap-5 text-[#AAAAAA] text-[13px] mb-8 sm:mb-12" data-id="element-187">
          <span className="flex items-center gap-1.5" data-id="element-188">
            <ShieldCheck size={16} className="text-verde" data-id="element-189" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-1.5" data-id="element-190">
            <Lock size={16} data-id="element-191" /> Pago seguro
          </span>
          <span className="flex items-center gap-1.5" data-id="element-192">
            <CreditCard size={16} className="text-blue-400" data-id="element-193" /> Mercado Pago
          </span>
          <span className="flex items-center gap-1.5" data-id="element-194">
            <Star size={16} className="text-dorado fill-dorado" data-id="element-195" /> +400
            Esteticistas
          </span>
          <span className="flex items-center gap-1.5" data-id="element-196">
            <Zap size={16} className="text-yellow-400 fill-yellow-400" data-id="element-197" /> Acceso
            en 5 min
          </span>
        </div>
      </div>
    </section>;
}